'use client';

import PrismoLogo from '@/assets/logos/prismo/light.svg';
import { Trans, t } from '@lingui/macro';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  Stack,
  Typography,
} from '@mui/material';
import { Button, SocialLogins } from '@prismo-io/design-system';
import Image from 'next/image';
import Link from 'next/link';
import { type FC, useState } from 'react';
import { SendPasswordResetForm } from '../../components/forms/send-reset-password/form';
import { SignInForm } from '../../components/forms/sign-in';
import { SignPaperCard } from '../../components/sign-paper-card';
import { useHubspot, usePoleEmploi } from '../../hooks';
import { useSignWithLinkedIn } from '../../hooks/use-sign-with-linkedin';

type Props = {
  type?: 'socials-only' | 'password-only' | 'all';
  email?: string;
  signUpUrl: string;
  successUrl: string;
};

export const FormCard: FC<Props> = (props) => {
  const { type = 'all', email = '', signUpUrl, successUrl } = props;

  const [emailForm, setEmailForm] = useState<string>(email);
  const [showChat, setShowChat] = useState<boolean>(false);
  const [resetPassword, setResetPassword] = useState<boolean>(false);

  const { trigger: signWithLinkedIn } = useSignWithLinkedIn();

  const hubspot = useHubspot();

  const onLinkedInSubmit = () => {
    signWithLinkedIn();
  };
  const canAccessChat = (can: boolean) => {
    setShowChat(can);
    hubspot.openChat();
  };

  const { trigger: goToPoleEmploi } = usePoleEmploi();

  const onPoleEmploiSubmit = () => {
    goToPoleEmploi();
  };

  return (
    <SignPaperCard display="block">
      <Stack
        gap={2}
        paddingY={{ none: 5, sm: 3 }}
        paddingX={3}
        height="100%"
        flex={1}
        position="relative"
      >
        <Box
          component="div"
          position="relative"
          height={25}
          display={{ none: 'none', sm: 'block' }}
        >
          <Image
            src={PrismoLogo}
            alt={t`Logo de PRISMO`}
            fill
            loading="eager"
          />
        </Box>

        <Typography variant="h1" textAlign="center">
          <Trans>Connexion</Trans>
        </Typography>

        {/* <Box component="div" position="absolute" top={0} right={16} visibility={showChat && type !== 'socials-only' ? 'visible' : 'hidden'}>
          <Chat visible={showChat && type !== 'socials-only'} />
        </Box> */}

        {type !== 'socials-only' && (
          <>
            <SignInForm
              defaultValues={{ email }}
              successUrl={successUrl}
              onEmailChange={setEmailForm}
              onSignInError={canAccessChat}
            />

            <Stack spacing={1} alignItems="center">
              <Stack direction="row" alignItems="center">
                <Trans>Pas encore de compte ?</Trans>{' '}
                <Button
                  LinkComponent={Link}
                  variant="text"
                  color="inherit"
                  href={signUpUrl}
                >
                  <Trans>Inscription</Trans>
                </Button>
              </Stack>

              <Button
                variant="text"
                color="inherit"
                onClick={() => setResetPassword(true)}
              >
                <Trans>Mot de passe oublié ?</Trans>
              </Button>
            </Stack>
          </>
        )}
        {type === 'all' && (
          <Divider
            sx={{
              fontSize: 'fontSize',
            }}
          >
            <Trans>ou</Trans>
          </Divider>
        )}
        {type !== 'password-only' && (
          <Stack spacing={2} alignItems="center">
            <SocialLogins
              onLinkedIn={onLinkedInSubmit}
              onPoleEmploi={onPoleEmploiSubmit}
            />
          </Stack>
        )}
      </Stack>

      <Dialog open={resetPassword} onClose={() => setResetPassword(false)}>
        <DialogTitle>
          <Trans>Réinitialisation du mot de passe</Trans>
        </DialogTitle>
        <DialogContent>
          <Box component="div" paddingY={1}>
            <SendPasswordResetForm
              onComplete={() => setResetPassword(false)}
              defaultValues={{ email: emailForm }}
            />
          </Box>
        </DialogContent>
      </Dialog>
    </SignPaperCard>
  );
};
